// -------------------------------------------------------------------------------
// Libraries
// -------------------------------------------------------------------------------

// -------------------------------------------------------------------------------
// Utils, Styles and Assets
// -------------------------------------------------------------------------------

// -------------------------------------------------------------------------------
// Component
// -------------------------------------------------------------------------------
const TimeBar = ({ backgroundColor, width, transition }) => {
  return (
    <div
      style={{
        backgroundColor,
        width: `${width}%`,
        transition,
        position: 'absolute',
        left: 0,
        top: 0,
        height: '100%',
        borderRadius: '100px',
      }}
    />
  );
};

export default TimeBar;
